// shared.
import { ButtonLogo, Sidebar } from '@shared';
import { ButtonDocumentsViewer } from './components/ButtonDocumentsViewer';
import { ButtonDocumentsTasks } from './components/ButtonDocumentsTasks';
import { ButtonReassignTasks } from './components/ButtonReassignTasks';
import { ButtonGeoreferencing } from './components/ButtonGeoreferencing';

export const SidebarDocuments = () => {
  return (
    <Sidebar
      upperButtons={
        <>
          <ButtonLogo />
          <ButtonDocumentsTasks />
          <ButtonDocumentsViewer />
          <ButtonReassignTasks />
          <ButtonGeoreferencing />
        </>
      }
    />
  );
};
